import { render, staticRenderFns } from "./teldata.vue?vue&type=template&id=6da9d446&scoped=true"
import script from "./teldata.vue?vue&type=script&lang=js"
export * from "./teldata.vue?vue&type=script&lang=js"
import style0 from "./teldata.vue?vue&type=style&index=0&id=6da9d446&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX-JYJ\\WEB\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da9d446",
  null
  
)

export default component.exports